import { render } from "./list.vue?vue&type=template&id=39c60438&scoped=true&ts=true"
import script from "./list.vue?vue&type=script&setup=true&lang=ts"
export * from "./list.vue?vue&type=script&setup=true&lang=ts"

import "./list.vue?vue&type=style&index=0&id=39c60438&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c60438"],['__file',"src/components/charts/list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39c60438"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39c60438', __exports__)) {
    console.log('reload')
    api.reload('39c60438', __exports__)
  }
  
  module.hot.accept("./list.vue?vue&type=template&id=39c60438&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('39c60438', render)
  })

}


export default __exports__